import { Link } from 'react-router-dom';
import { IndicatorCell, INDICATOR_TYPES } from '../../../../components';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';

export const leftSpacer = { id: 'leftSpacer', style: { width: '2%' } };

export const rightSpacer = { id: 'rightSpacer', style: { width: '2%' } };

export const answeredCorrectly = {
  id: 'answeredCorrectly',
  Header: 'Answered correctly',
  accessor: (row) =>
    row.get('answer') ? `${row.get('correct') ? 'Yes' : 'No'}` : 'Not answered',
  Cell: (cell) =>
    cell.row.original.get('answer') ? (
      <IndicatorCell
        value={cell.value}
        indicatorType={
          cell.row.original.get('correct')
            ? INDICATOR_TYPES.POSITIVE
            : INDICATOR_TYPES.NEGATIVE
        }
      />
    ) : (
      <IndicatorCell
        value={cell.value}
        indicatorType={INDICATOR_TYPES.NEUTRAL}
      />
    ),
  sortType: (rowA, rowB) => {
    const isCorrectSortOrder = [true, false, null];

    if (
      isCorrectSortOrder.indexOf(rowA.original.get('correct')) >
      isCorrectSortOrder.indexOf(rowB.original.get('correct'))
    ) {
      return 1;
    }

    if (
      isCorrectSortOrder.indexOf(rowA.original.get('correct')) ===
      isCorrectSortOrder.indexOf(rowB.original.get('correct'))
    ) {
      return rowA.original.get('answer') > rowB.original.get('answer') ? 1 : -1;
    }

    return -1;
  },
};

export const selfReflection = {
  id: 'selfReflection',
  Header: 'Self-reflection',
  accessor: (row) => {
    if (row.get('grokked') === QUESTION_GROKKED.YES) {
      return 'Understands';
    }
    if (row.get('grokked') === QUESTION_GROKKED.NO) {
      return 'Needs help';
    }
    return 'Not reflected';
  },
  Cell: (cell) => {
    if (cell.row.original.get('grokked') === QUESTION_GROKKED.YES) {
      return (
        <IndicatorCell
          value={cell.value}
          indicatorType={INDICATOR_TYPES.POSITIVE}
        />
      );
    }
    if (cell.row.original.get('grokked') === QUESTION_GROKKED.NO) {
      return (
        <IndicatorCell
          value={cell.value}
          indicatorType={INDICATOR_TYPES.NEGATIVE}
        />
      );
    }
    return (
      <IndicatorCell
        value={cell.value}
        indicatorType={INDICATOR_TYPES.NEUTRAL}
      />
    );
  },
  sortType: (rowA, rowB) => {
    const sortOrder = [
      QUESTION_GROKKED.YES,
      QUESTION_GROKKED.NO,
      QUESTION_GROKKED.NO_RESPONSE,
      null,
    ];

    if (
      sortOrder.indexOf(rowA.original.get('grokked')) >
      sortOrder.indexOf(rowB.original.get('grokked'))
    ) {
      return 1;
    }
    return -1;
  },
};

export const name = (getStudentCourseProgressUrl) => {
  return {
    id: 'name',
    Header: 'Name',
    accessor: (row) => (
      <Link
        to={getStudentCourseProgressUrl(row.get('userProfileId'))}
      >{`${row.get('userFirstName')} ${row.get('userLastName')}`}</Link>
    ),
    sortType: (rowA, rowB) =>
      `${rowA.original.get('userLastName')} ${rowA.original.get(
        'userFirstName'
      )}`.toLowerCase() >
      `${rowB.original.get('userLastName')} ${rowB.original.get(
        'userFirstName'
      )}`.toLowerCase()
        ? 1
        : -1,
  };
};
